import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ControllerTextInput from '../SharedComponents/formComponents/baseFormComponents/ControllerTextInput';
import Arrow from './assets/icons/Arrow';
import api from '../../api';
import apiPublic from '../../apiPublic';

const OfferPage = () => {
  const [data, setData] = useState(null);
  const [generationName, setGenerationName] = useState('');
  const [makeName, setMakeName] = useState('');
  const { control, handleSubmit } = useForm();
  const [error, setError] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('formData');
    try {
      if (saved) {
        const parsed = JSON.parse(saved);
        setData(parsed);
      }
    } catch (e) {
      console.error('Greška pri čitanju formData iz localStorage.');
    }
  }, []);

  useEffect(() => {
    const fetchInfo = async () => {
      if (!data) return;

      try {
        if (data.godina) {
          const resGen = await apiPublic.get(`/onboarding/generation/${data.godina}`);
          setGenerationName(resGen.data || '');
        }
        if (data.marka) {
          const resMarka = await apiPublic.get(`/onboarding/make/${data.marka}`);
          setMakeName(resMarka.data || '');
        }
      } catch (err) {
        console.error('Greška pri dohvatima podataka za marku i generaciju.');
      }
    };

    fetchInfo();
  }, [data]);

  const onSubmit = async (formValues) => {
    const finalData = { ...data, phoneNumber: formValues.phoneNumber };

    try {
      const response = await api.post('/onboarding/set-phone-number', {
        phoneNumber: formValues.phoneNumber,
        email: data.email,
      });
      console.log('Phone number set successfully:', response.data);
    } catch (err) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Greška pri postavljanju broja telefona. Pokušaj ponovo.');
      }
    }
  };

  if (!data) {
    return <p style={styles.noData}>Nema podataka. Vrati se nazad.</p>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Pronašli smo tvoj zahtev!</h2>
      <div style={styles.previewBox}>
        {makeName ? makeName.name : 'N/A'}• {generationName ? generationName.name : 'N/A'} • {data.brojSasije}
        <p>{data.opis}</p>
      </div>
      <p style={styles.subtitle}>Ponuda koju smo pronašli</p>

      <div style={styles.offerBox}>
        <img
          src="slika"
          alt="Ponuda branika"
          style={styles.offerImage}
        />
        <div style={styles.offerDetails}>
          <h3 style={styles.offerPrice}>Cena</h3>
          <p style={styles.offerMeta1}>Garancija</p>
          <p style={styles.offerMeta2}>Lokacija dostava</p>
          <p style={styles.offerText}>
            Opis
          </p>
        </div>
      </div>

      <p style={styles.text}>
        Potreban nam je tvoj broj telefona da bismo te povezali sa prodavcem. <br />
        Unesi broj telefona da bi video ponudu:
      </p>
      <form onSubmit={handleSubmit(onSubmit)} style={styles.inputGroup}>
        <ControllerTextInput
          name="phoneNumber"
          control={control}
          defaultValue=""
          placeholder="Tvoj broj telefona"
          styleForInput={{
            color: 'white',
            border: '1px solid #787878',
          }}
          width={254}
        />
        <button type="submit" style={styles.button}>
          Pogledaj ponudu
          <Arrow />
        </button>
      </form>
      {error && <p style={styles.error}>{error}</p>}
      <footer style={styles.footer}>
        Copyright © 2025. SmartPart d.o.o. • Sva prava zadržana
      </footer>
    </div>
  );
};

export default OfferPage;

const styles = {
  container: {
    backgroundColor: '#171718',
    color: '#fff',
    minHeight: '100vh',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '34px',
    lineHeight: '42px',
    fontWeight: 400,
    color: '#fff',
    textAlign: 'left',
  },
  previewBox: {
    backgroundColor: '#f5f5f5',
    color: '#000',
    padding: 20,
    borderRadius: 6,
    textAlign: 'left',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 400,
    color: '#fff',
    textAlign: 'center',
  },
  text: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#fff',
    textAlign: 'center',
    marginBottom: '30px'
  },
  inputGroup: {
    display: 'flex',
    gap: 12,
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#d3e205',
    fontWeight: 'bold',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    gap: 10,
  },
  footer: {
    textAlign: 'center',
    marginTop: 'auto',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  error: {
    color: 'white',
    marginTop: 12,
  },
  offerBox: {
    display: 'flex',
    borderRadius: 8,
    border: '1px solid',
    opacity: 1,
    backgroundColor: 'rgba(243, 244, 246, 1)',
    overflow: 'hidden',
    marginBottom: 20,
    flexWrap: 'wrap',
    maxWidth: 800,
  },
  offerImage: {
    width: 250,
    objectFit: 'cover',
  },
  offerDetails: {
    padding: 16,
    color: 'black',
    flex: 1,
    minWidth: 250,
  },
  offerPrice: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16,
    fontWeight: 600,
    fontStyle: 'SemiBold',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '24px',
    margin: '0 0 8px 0',
  },
  offerMeta1: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'Regular',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '20px',
  },
  offerMeta2: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'Regular',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '20px',
  },
  offerText: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 16,
    fontWeight: 400,
    fontStyle: 'Regular',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '24px',
    marginTop: 12,
  },
  noData: {
    textAlign: 'center',
    marginTop: 80
  }
};
